export default __webpack_public_path__ + "static/media/by_4.8bf6a0d3.mp3";